import { Component, OnInit, Input } from '@angular/core';

import { Observable ,  of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, tap, switchMap } from 'rxjs/operators';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-jockey-change',
  templateUrl: './jockey-change.component.html',
  styleUrls: ['./jockey-change.component.scss']
})
export class JockeyChangeComponent implements OnInit {
  @Input() jockey;
  meta: {
    loading: boolean;
    loadingFailed: boolean;
    saving: boolean;
  };
  userId: number;
  jockeyList: [any];
  jockeyChange: {
    newJockey: any;
    jockeyName: string;
    noFilter: boolean;
  };

  constructor(public activeModal: NgbActiveModal, private apiService: ApisService, private notification: ToastrService) {}

  ngOnInit() {
    this.meta = {
      loading: false,
      loadingFailed: false,
      saving: false
    };
    this.jockeyChange = {
      newJockey: null,
      jockeyName: '',
      noFilter: false
    };

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });
  }

  cleanUp = (value, target) => {
    // console.log(value, target, this.jockeyChange[target]);
    this.jockeyChange[target] = null;
    if (target === 'jockeyId') {
      this.jockeyChange.jockeyName = value;
    }
    if (target === 'jockeyName') {
      this.jockeyChange.newJockey = value;
    }
  }

  switchFilters() {
    this.jockeyChange.newJockey = null;
    this.jockeyChange.jockeyName = null;
  }

  jockeyFormat = (x: { jockeyName: string }) => x.jockeyName;
  searchJockeys = (query$: Observable<string>) =>
    query$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      map(q => q),
      // tap(() => this.meta.loading = true),
      switchMap(q => {
        // console.log('got', q);
        if (q.length > 2) {
          return this.apiService.getJockeyList(q, this.jockey, this.jockeyChange.noFilter).pipe(
            map(res => res.slice(0, 6)),
            tap(() => (this.meta.loadingFailed = false)),
            catchError(err => {
              console.log(`Error getting jockeys`, err);
              this.meta.loadingFailed = true;
              return of([]);
            })
          );
        } else {
          return of([]);
        }
      }),
      tap(() => (this.meta.loading = false))
    )

  resetWeighOut() {
    return new Promise((resolve, reject) => {
      const payload = {
        animalId: this.jockey.animalId,
        jockeyId: Number(this.jockey.jockeyId),
        yearOfRace: this.jockey.yearOfRace,
        raceId: this.jockey.raceId,
        divisionSequence: this.jockey.divisionSequence,
        weightDisplayed: null,
        jockeyOverweight: null,
        raw: null,
        weighed: 'O',
        type: 'M',
        updatedBy: this.userId
      };
      console.log(`[ DEBUG ] Resetting weigh-out:`, payload);
      this.apiService
        .updateJockeyWeights(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
        .subscribe(res => resolve(res), err => reject(err));
    });
  }

  confirm() {
    // console.log(this.jockeyChange);
    this.meta.saving = true;
    const payload = {
      animalId: this.jockey.animalId,
      yearOfRace: this.jockey.yearOfRace,
      raceId: this.jockey.raceId,
      divisionSequence: this.jockey.divisionSequence,
      jockeyId: this.jockeyChange.newJockey ? this.jockeyChange.newJockey.jockeyId : null,
      jockeyName: this.jockeyChange.jockeyName ? this.jockeyChange.jockeyName : this.jockeyChange.newJockey.jockeyName,
      jockeyClaim: this.jockeyChange.newJockey ? this.jockeyChange.newJockey.jockeyClaim || 0 : 0,
      updatedBy: this.userId
    };

    console.log('[ DEBUG ] Sending payload:', payload);
    this.apiService.changeJockey(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload).subscribe(
      resChangeJockey => {
        this.notification.success(`${this.jockey.animalName}'s' jockey has been changed.`, 'Jockey Change');
        // console.log('[ DEBUG ] Jockey Data Saved:', res);
        this.resetWeighOut()
          .then(resWeighOut => {
            resChangeJockey.resetWeighOut = true;
            this.activeModal.close(resChangeJockey);
          })
          .catch(errWeighOut => {
            console.error('[ DEBUG ] Error resetting weigh-out after changing Jockey', errWeighOut);
            this.meta.saving = false;
            resChangeJockey.resetWeighOut = false;
            this.activeModal.close(resChangeJockey);
            this.notification.error(`Could't reset the weigh-out of the Jockey.
            Please remember to weigh-out again.`, 'Weigh-Out', { disableTimeOut: true });
          });
      },
      errChangeJockey => {
        console.error('[ DEBUG ] Error changing Jockey', errChangeJockey);
        this.notification.error(`Could't update the Jockey. Check your connection and Try again.`, 'Jockey Change');
        this.meta.saving = false;
      }
    );
  }

  reset() {
    this.meta.saving = true;
    const payload = {
      animalId: this.jockey.animalId,
      yearOfRace: this.jockey.yearOfRace,
      raceId: this.jockey.raceId,
      divisionSequence: this.jockey.divisionSequence,
      jockeyId: null,
      jockeyName: null,
      updatedBy: this.userId
    };
    // console.log('[ DEBUG ] Sending payload:', payload);
    this.apiService.changeJockey(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload).subscribe(
      res => {
        // console.log('[ DEBUG ] Jockey Data Saved:', res);
        this.activeModal.close(res);
        this.notification.success(`Horse's Jockey restored to the declared one.`, 'Jockey Change');
      },
      err => {
        console.error('[ DEBUG ] Error deleting Race Claim', err);
        this.notification.error(`Could't restore the jockey. Check your connection and Try again.`, 'Jockey Change');
        this.meta.saving = false;
      }
    );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }
}
